export class Adresse {
  strasse = "";
  hausnummer = "";
  plz = "";
  ort = "";

  //Frontend-spezifische Erweiterungen
  zuPruefen = false;
  sollPruefen = false;
  wurdeGeprueft = false;
}
